import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const AccessibilityContext = createContext(null);
const LS_KEY = "mmm_a11y";
const DEFAULTS = { textSize: "standard", highReadability: false, reducedMotion: false };

const loadPrefs = () => {
  try {
    return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(LS_KEY) || "{}") };
  } catch {
    return { ...DEFAULTS };
  }
};

export const AccessibilityProvider = ({ children }) => {
  const [prefs, setPrefs] = useState(loadPrefs);

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute("data-text-size", prefs.textSize);
    root.setAttribute("data-high-readability", String(prefs.highReadability));
    root.setAttribute("data-reduced-motion", String(prefs.reducedMotion));
    localStorage.setItem(LS_KEY, JSON.stringify(prefs));
  }, [prefs]);

  const setTextSize = useCallback((textSize) => setPrefs((p) => ({ ...p, textSize })), []);
  const setHighReadability = useCallback((v) => setPrefs((p) => ({ ...p, highReadability: !!v })), []);
  const setReducedMotion = useCallback((v) => setPrefs((p) => ({ ...p, reducedMotion: !!v })), []);
  const reset = useCallback(() => setPrefs({ ...DEFAULTS }), []);

  return (
    <AccessibilityContext.Provider
      value={{ ...prefs, setTextSize, setHighReadability, setReducedMotion, reset }}
    >
      {children}
    </AccessibilityContext.Provider>
  );
};

export const useAccessibility = () => useContext(AccessibilityContext);
